<template>
  <CockpitDialog
    :title="`${deviceName}设备风险分级管控清单`"
    left="380px"
    width="990px"
    height="650px"
    top="120px"
    @close="dialogVisible = false"
  >
    <div class="h-full">
      <el-table :data="tableData" height="calc(100% - 48px)" v-loading="loading">
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="危险源" prop="name" show-overflow-tooltip width="160" />
        <el-table-column label="危害因素" prop="factor" show-overflow-tooltip width="160" />
        <el-table-column label="安全">
          <template slot-scope="scope">{{ scope.row.riskRange.includes(1) ? '√' : '' }}</template>
        </el-table-column>
        <el-table-column label="健康">
          <template slot-scope="scope">{{ scope.row.riskRange.includes(2) ? '√' : '' }}</template>
        </el-table-column>
        <el-table-column label="环保">
          <template slot-scope="scope">{{ scope.row.riskRange.includes(3) ? '√' : '' }}</template>
        </el-table-column>
        <el-table-column label="风险等级" prop="riskLevelText" show-overflow-tooltip />
        <el-table-column
          label="运行巡回检查措施"
          prop="runningCheckMeasure"
          show-overflow-tooltip
          width="200"
        />
        <el-table-column
          label="点检检修检查措施"
          prop="pointCheckMeasure"
          show-overflow-tooltip
          width="200"
        />
        <el-table-column
          label="定期维护措施"
          prop="regularMaintainMeasure"
          show-overflow-tooltip
          width="200"
        />
        <el-table-column
          label="管理人员检查措施"
          prop="managerCheckMeasure"
          show-overflow-tooltip
          width="200"
        />
        <el-table-column label="运行人员" prop="runnerNames" width="200" show-overflow-tooltip />
        <el-table-column
          label="维护人员"
          prop="maintainerNames"
          width="200"
          show-overflow-tooltip
        />
        <el-table-column
          label="安全管理人员"
          prop="safetyManagerNames"
          width="200"
          show-overflow-tooltip
        />
        <el-table-column
          label="评估负责人及小组"
          prop="evaluationManagerNames"
          show-overflow-tooltip
          width="200"
        />
      </el-table>
      <div class="mt-10px text-center">
        <el-pagination
          background
          @size-change="findList"
          @current-change="searchList"
          :current-page.sync="page.pageNo"
          :page-size.sync="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </CockpitDialog>
</template>

<script>
import { RiskAreaEvaluationApi } from '@wiz-api/huizhou2-business'
import CockpitDialog from '@/components/cockpit/CockpitDialog'

const riskAreaEvaluationApi = new RiskAreaEvaluationApi()
export default {
  props: {
    deviceName: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    areaManagementAreaId: {
      type: String,
      default: '',
    },
  },
  components: {
    CockpitDialog,
  },
  data() {
    return {
      tableData: [],
      loading: false,
      page: {
        pageNo: 1,
        pageSize: 15,
      },
      total: 0,
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  methods: {
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async findList() {
      const [err, res] = await riskAreaEvaluationApi.getByPage({
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        device: this.deviceName,
        areaManagementAreaId: this.areaManagementAreaId,
      })
      if (!err) {
        this.tableData = res.items.map((item) => {
          item.evaluationManagerNames = item.evaluationManagerNames?.join('、')
          item.maintainerNames = item.maintainerNames?.join('、')
          item.runnerNames = item.runnerNames?.join('、')
          item.safetyManagerNames = item.safetyManagerNames?.join('、')
          if (item.riskValue <= 20) {
            item.riskLevelText = '低风险'
          } else if (item.riskValue < 200) {
            item.riskLevelText = '中风险'
          } else {
            item.riskLevelText = '高风险'
          }
          return item
        })
        this.total = res.totalCount
      }
    },
  },
  created() {
    this.searchList()
  },
}
</script>

<style></style>
